import React from "react";
import { render, screen, fireEvent, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";
import { HeartbeatPanel } from "./HeartbeatPanel";
import { useAuthFetch } from "../../../utils/useAuthFetch";
jest.mock("../../../utils/useAuthFetch");
jest.mock("./HeartbeatEditor", () => ({ HeartbeatEditor: () => null }));
const authFetch = jest.fn();
const heartbeat = {
  task_id: "hb-1",
  kind: "cron",
  status: "active",
  prompt: "Check pipeline",
  conversation_id: 123,
  next_fire_at: "2026-10-02T09:00:00Z",
};
beforeEach(() => {
  jest.clearAllMocks();
  (useAuthFetch as jest.Mock).mockReturnValue(authFetch);
});
it("X sends the cancel endpoint and refreshes until the row disappears", async () => {
  let active = true;
  authFetch.mockImplementation(
    async (url: string, _tag: string, init?: RequestInit) => {
      if (init?.method === "DELETE") {
        active = false;
        return { status: "cancelled", task_id: "hb-1" };
      }
      return { items: active ? [heartbeat] : [], scheduler_available: true };
    },
  );
  render(<HeartbeatPanel workspaceId="ws-1" isAdmin />);
  const toggle = await screen.findByTestId("heartbeat-panel-toggle");
  expect(toggle).toBeInTheDocument();
  fireEvent.click(toggle);
  fireEvent.click(screen.getByTestId("heartbeat-cancel-hb-1"));
  await waitFor(() =>
    expect(authFetch).toHaveBeenCalledWith(
      "/api/workspace/ws-1/scheduler/tasks/hb-1",
      "heartbeat cancel",
      { method: "DELETE" },
    ),
  );
  await waitFor(() =>
    expect(screen.queryByTestId("heartbeat-panel")).not.toBeInTheDocument(),
  );
  expect(
    authFetch.mock.calls.filter(([, tag]) => tag === "heartbeat list"),
  ).toHaveLength(2);
});
it("shows a cancel refusal and keeps the heartbeat available for retry", async () => {
  authFetch.mockImplementation(
    async (_url: string, _tag: string, init?: RequestInit) => {
      if (init?.method === "DELETE") throw new Error("Access denied");
      return { items: [heartbeat], scheduler_available: true };
    },
  );
  render(<HeartbeatPanel workspaceId="ws-1" isAdmin />);
  const toggle = await screen.findByTestId("heartbeat-panel-toggle");
  expect(toggle).toBeInTheDocument();
  fireEvent.click(toggle);
  fireEvent.click(screen.getByTestId("heartbeat-cancel-hb-1"));
  expect(await screen.findByRole("alert")).toHaveTextContent("Access denied");
  expect(screen.getByTestId("heartbeat-cancel-hb-1")).toBeEnabled();
});
